import { CancelToken } from "axios";
import { doGet, doPost } from "./gateway/carexGateway";

const UserMetrics = {
    trackEvent: async (payload: any, cancelToken?: CancelToken) => {
        try {
            const data = payload.data?.event || payload.data;
            const res: any = await doPost("trackUserMetricEvent", {
                data,
                cancelToken,
            });
            return Promise.resolve(res.data);
        } catch (error) {
            //eslint-disable-next-line
            console.log("error", error);
            Promise.reject(error);
        }
    },

    trackEventsBatch: async (payload: any, cancelToken?: CancelToken) => {
        try {
            const data = payload.data?.events || payload.data;
            const res: any = await doPost("trackUserMetricEventsBatch", {
                data,
                cancelToken,
            });
            return Promise.resolve(res.data);
        } catch (error) {
            //eslint-disable-next-line
            console.log("error", error);
            Promise.reject(error);
        }
    },

    getEvents: async (config: any, cancelToken?: CancelToken) => {
        try {
            const queryParams = new URLSearchParams();
            if (config.offset !== undefined) {
                queryParams.append("offset", config.offset.toString());
            }
            if (config.limit !== undefined) {
                queryParams.append("limit", config.limit.toString());
            }
            if (config.eventCategory) {
                queryParams.append("eventCategory", config.eventCategory);
            }
            if (config.eventType) {
                queryParams.append("eventType", config.eventType);
            }
            if (config.idUser) {
                queryParams.append("idUser", config.idUser.toString());
            }
            if (config.idGroup) {
                queryParams.append("idGroup", config.idGroup.toString());
            }
            if (config.startDate) {
                queryParams.append("startDate", config.startDate);
            }
            if (config.endDate) {
                queryParams.append("endDate", config.endDate);
            }

            const query = queryParams.toString();
            const res: any = await doGet("getUserMetricEvents", { query }, cancelToken);
            return Promise.resolve(res.data);
        } catch (error) {
            //eslint-disable-next-line
            console.log("error", error);
            Promise.reject(error);
        }
    },
};

export default UserMetrics;
